import * as React from 'react';

interface UseToggleStateResponse {
  isOpen: boolean;
  handleClose: () => void;
  handleOpen: () => void;
}

export default (): UseToggleStateResponse => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const handleClose = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);
  return {
    isOpen,
    handleClose,
    handleOpen,
  };
};
